/* eslint-disable */

import React from 'react'
import gql from 'graphql-tag'
import { connect } from 'react-redux'
import {formValueSelector } from 'redux-form'

import { gqlQuery } from '../../../../alelo-logic/services/common/apolloClient'

import CheckboxItem from './CheckboxItem'
import {
  ServicesCheckboxesContainer,
  ServicesCheckboxes,
  Container,
  Content,
  Title,
} from './styles'

export const gqlValePedagio = gql`
  query valePedagio($idConta: String) {
    valePedagio(idConta: $idConta) {
      valePedagio
    }
  }
`

class FilterByServices extends React.Component {
  state = {
    loadingValePedagio: true
  }

  async componentDidMount() {
    const { data } = await gqlQuery(gqlValePedagio, {idConta: this.props.activePlanId})
    this.setState({ loadingValePedagio: false})
    this.props.setHasValePedagio(data.valePedagio.valePedagio)
  }

  render() {
    return (
      <Container>
        <Content>
          <Title>Serviços</Title>
          <ServicesCheckboxesContainer>
            <ServicesCheckboxes>
              <CheckboxItem
                disabled={this.state.loadingValePedagio}
                label="Estacionamento"
                onChange={this.props.onChange}
                setServicesRef={this.props.setServicesRef}
                typeValue="ESTACIONAMENTO"
                name="type"
                index={1}
              />
              <CheckboxItem
                disabled={this.state.loadingValePedagio}
                label="Pedágio"
                onChange={this.props.onChange}
                setServicesRef={this.props.setServicesRef}
                typeValue="PEDAGIO"
                name="type"
                index={2}
              />
              { this.props.hasValePedagio && <CheckboxItem
                selectedTypes={this.props.selectedTypes}
                label="Vale Pedágio"
                onChange={this.props.onChange}
                setServicesRef={this.props.setServicesRef}
                typeValue="VALE_PEDAGIO"
                name="type"
                index={3}
              />
              }
            </ServicesCheckboxes>
          </ServicesCheckboxesContainer>
        </Content>
      </Container>
    )
  }
  
}
const formSelector = formValueSelector('statementsFilter',)
export default connect(state => ({
  selectedTypes: formSelector(state, 'type')
}))(FilterByServices)



// WEBPACK FOOTER //
// ./src/app/modules/StatementsFilterForm/FilterByServices/FilterByServices.js